import { iconPaths as _iconPaths } from './constants/_iconPaths';
import * as icons from './constants/iconPaths';

export const iconPaths = { ...icons, ..._iconPaths };

export { default as Accordion } from './atoms/Accordion';
export { default as Avatar } from './atoms/Avatar';
export { default as Button } from './atoms/Button';
export { default as ButtonGroup } from './atoms/ButtonGroup';
export { default as Checkbox } from './atoms/Checkbox';
export { default as Col } from './atoms/Col';
export { default as Collapse } from './atoms/Collapse';
export { default as Container } from './atoms/Container';
export { default as Div } from './atoms/Div';
export { default as Autocomplete } from './atoms/Autocomplete';
export { default as Dropdown } from './atoms/Dropdown';
export { default as DropdownMenu } from './atoms/DropdownMenu';
export { default as Icon } from './atoms/Icon';
export { default as Image } from './atoms/Image';
export { default as Input } from './atoms/Input';
export { default as InputGroup } from './atoms/InputGroup';
export { default as Label } from './atoms/Label';
export { default as Anchor } from './atoms/Anchor';
export { default as Radiobox } from './atoms/Radiobox';
export { default as Row } from './atoms/Row';
export { default as StyleReset } from './atoms/StyleReset';
export { default as Switch } from './atoms/Switch';
export { default as Tab } from './atoms/Tab';
export { default as Tag } from './atoms/Tag';
export { default as Text } from './atoms/Text';
export { default as Textarea } from './atoms/Textarea';
export { default as Modal } from './atoms/Modal';
export { default as SideDrawer } from './atoms/SideDrawer';
export { default as Slideshow } from './atoms/Slideshow';
export { default as SimpleSlideshow } from './atoms/SimpleSlideshow';
export { default as Notification } from './atoms/Notification';
export { default as Loader } from './atoms/Loader';
export { default as Skeleton } from './atoms/Skeleton';
export { default as Content } from './atoms/Content';
export { default as Application } from './atoms/Application';
export { default as MessageAlerts } from './atoms/MessageAlerts';
export { default as Table, ExpanderColumn, Pagination } from './atoms/Table';
export { default as scrollTo } from './functions/_scrollTo';
export { default as currentDevice } from './functions/_currentDevice';

export { withTheme, ThemeProvider } from './core/theming';
export { default as DefaultTheme } from './styles/DefaultTheme';
